/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnforcementStateEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type MeetingReliefSettingVisibility = "DisabledByPaywall" | "HideSetting" | "ShowWithBadge" | "ShowWithoutBadge" | "%future added value";
export type PaymentStatusBadgeTextEnum = "Business" | "Enterprise" | "Free" | "Pro" | "%future added value";
export type PaymentStatusBadgeTypeEnum = "Blue" | "Gradient" | "%future added value";
export type ProductTypeEnum = "Business_NonStandard" | "Business_Standard" | "Enterprise_NonStandard" | "Enterprise_Standard" | "Pro_NonStandard" | "Pro_Standard" | "%future added value";
export type QuotaAutopilotStatusCalloutEnumType = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type QuotaStatusBannerEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type QuotaStatusBannerEnumType = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type SubscriptionTypeEnum = "Expired" | "FreemiumOrg" | "LegacyPrePaywall" | "PaidBillingGroup" | "PaidOrgPro" | "PaidTeamPro" | "PaidUserPro" | "SelfServePremiumOrgQ42020" | "SelfServePremiumTeamQ12021" | "%future added value";
export type PlanStatusRefetch_org = {
    readonly id: string;
    readonly orgAccountingPeriod: {
        readonly __typename: "OrgAccountingPeriod";
        readonly periodRange: {
            readonly minDate: string;
            readonly maxDate: string;
        };
        readonly quotaMax: number;
        readonly quotaUsed: number;
        readonly enforcementState: EnforcementStateEnum;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly featureGrid: {
        readonly __typename: "FeatureGrid";
        readonly featureStates: {
            readonly quotaStatusBanner: QuotaStatusBannerEnumType;
            readonly quotaAutopilotStatusCallout: QuotaAutopilotStatusCalloutEnumType;
            readonly mixedFreemiumOrgUIState: {
                readonly quotaStatusBanner: QuotaStatusBannerEnum;
                readonly autopilotPaused: boolean;
                readonly moveRangesEnabled: boolean;
                readonly paymentStatusBadge: {
                    readonly text: PaymentStatusBadgeTextEnum;
                    readonly type: PaymentStatusBadgeTypeEnum;
                } | null;
            };
            readonly meetingReliefSettingVisibility: MeetingReliefSettingVisibility;
        };
        readonly stateMetadata: {
            readonly primaryBillingGroupMetadata: {
                readonly subscription: {
                    readonly id: string;
                    readonly type: SubscriptionTypeEnum | null;
                    readonly productType: ProductTypeEnum | null;
                };
            } | null;
            readonly userMetadata: {
                readonly person: {
                    readonly primaryCalendarId: string;
                };
                readonly trialMetadata: {
                    readonly trialEndDate: string;
                    readonly timeZone: string;
                } | null;
            } | null;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "PlanStatusRefetch_org";
};
export type PlanStatusRefetch_org$data = PlanStatusRefetch_org;
export type PlanStatusRefetch_org$key = {
    readonly " $data"?: PlanStatusRefetch_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PlanStatusRefetch_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quotaStatusBanner",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "PlanStatusRefetch_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgAccountingPeriod",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DateRange",
                                "kind": "LinkedField",
                                "name": "periodRange",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minDate",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxDate",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaMax",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaUsed",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enforcementState",
                                "storageKey": null
                            }
                        ],
                        "type": "OrgAccountingPeriod",
                        "abstractKey": null
                    },
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "featureGrid",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FeatureStates",
                                "kind": "LinkedField",
                                "name": "featureStates",
                                "plural": false,
                                "selections": [
                                    (v3 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "quotaAutopilotStatusCallout",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MixedFreemiumOrgUiState",
                                        "kind": "LinkedField",
                                        "name": "mixedFreemiumOrgUIState",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "autopilotPaused",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "moveRangesEnabled",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "PaymentStatusBadge",
                                                "kind": "LinkedField",
                                                "name": "paymentStatusBadge",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "text",
                                                        "storageKey": null
                                                    },
                                                    (v4 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "meetingReliefSettingVisibility",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentStateMetadata",
                                "kind": "LinkedField",
                                "name": "stateMetadata",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PrimaryBillingGroupMetadata",
                                        "kind": "LinkedField",
                                        "name": "primaryBillingGroupMetadata",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "PaymentSubscription",
                                                "kind": "LinkedField",
                                                "name": "subscription",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    (v4 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "productType",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserMetadata",
                                        "kind": "LinkedField",
                                        "name": "userMetadata",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgPerson",
                                                "kind": "LinkedField",
                                                "name": "person",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "primaryCalendarId",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TrialMetadata",
                                                "kind": "LinkedField",
                                                "name": "trialMetadata",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "trialEndDate",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "timeZone",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "FeatureGrid",
                        "abstractKey": null
                    },
                    (v2 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'bccf9b384de7f2b1e1a16eab3e856222';
export default node;
